import { mapState } from 'vuex';
export default {
  name: 'CoreDrawerLogo',
  props: {
    hasDefaultLogo: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '',
      required: true
    },
    logo: {
      type: String,
      default: ''
    },
    orientation: {
      type: String,
      default: 'landscape'
    },
    byLine: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('app', ['UiTheme', 'miniVariant', 'themes', 'sidebarIconLink']),
    specLetter() {
      if (this.byLine) {
        return this.byLine.substring(0, 1);
      }
      return 'N20';
    }
  }
};